<script setup lang="ts">
import { Edit3, Minimize, CheckCircle, Sparkles, Languages, FileText } from 'lucide-vue-next';

const rows = [
  { key: 'rewrite', label: 'Rewrite', desc: 'Say the same thing in a different way.', icon: Edit3 },
  {
    key: 'refine',
    label: 'Refine',
    desc: 'Trim extra words and keep the core idea.',
    icon: Minimize,
  },
  {
    key: 'professional',
    label: 'Professional',
    desc: 'Make the tone more polished and formal.',
    icon: CheckCircle,
  },
  {
    key: 'brand',
    label: 'Brand Voice',
    desc: 'Push the copy closer to your product voice.',
    icon: Sparkles,
  },
  { key: 'concise', label: 'Concise', desc: 'Make the text shorter and tighter.', icon: Minimize },
  {
    key: 'translate',
    label: 'Translate',
    desc: 'Translate between English and other languages.',
    icon: Languages,
  },
  {
    key: 'correct',
    label: 'Correct',
    desc: 'Fix grammar, typos, and awkward phrasing.',
    icon: CheckCircle,
  },
  {
    key: 'expand',
    label: 'Expand',
    desc: 'Add more detail on top of the current text.',
    icon: FileText,
  },
  { key: 'summary', label: 'Summarize', desc: 'Generate a short summary.', icon: FileText },
];
</script>

<template>
  <div class="doc-table-ai-presets my-4 min-w-0 overflow-x-auto">
    <table class="doc-tt w-full border-collapse text-[0.875rem] leading-[1.5]">
      <thead>
        <tr>
          <th class="doc-tt-th doc-tt-col1">Icon</th>
          <th class="doc-tt-th doc-tt-col2">Preset</th>
          <th class="doc-tt-th doc-tt-col3">Effect</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in rows" :key="row.key">
          <td class="doc-tt-td doc-tt-col1">
            <div class="doc-tt-s">
              <component
                :is="row.icon"
                :size="14"
                class="shrink-0 text-black/50 dark:text-white/50"
              />
            </div>
          </td>
          <td class="doc-tt-td doc-tt-col2">{{ row.label }}</td>
          <td class="doc-tt-td doc-tt-col3">{{ row.desc }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
.doc-tt {
  table-layout: fixed;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  overflow: hidden;
}

.dark .doc-tt {
  border-color: rgba(255, 255, 255, 0.08);
}

.doc-tt-th,
.doc-tt-td {
  padding: 0.55rem 0.7rem;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  word-break: break-word;
  overflow-wrap: anywhere;
}

.dark .doc-tt-th,
.dark .doc-tt-td {
  border-bottom-color: rgba(255, 255, 255, 0.06);
}

.doc-tt-th {
  background: rgba(0, 0, 0, 0.03);
  font-weight: 600;
  font-size: 0.84rem;
  color: rgba(0, 0, 0, 0.55);
  letter-spacing: 0.01em;
}

.dark .doc-tt-th {
  background: rgba(255, 255, 255, 0.04);
  color: rgba(255, 255, 255, 0.5);
}

.doc-table-ai-presets .doc-tt th:nth-child(1),
.doc-table-ai-presets .doc-tt td:nth-child(1),
.doc-tt-col1 {
  width: 25% !important;
}

.doc-table-ai-presets .doc-tt th:nth-child(2),
.doc-table-ai-presets .doc-tt td:nth-child(2),
.doc-tt-col2 {
  width: 25% !important;
}

.doc-table-ai-presets .doc-tt th:nth-child(3),
.doc-table-ai-presets .doc-tt td:nth-child(3),
.doc-tt-col3 {
  width: 50% !important;
}

tbody tr:last-child td {
  border-bottom: 0;
}

.doc-tt-s {
  pointer-events: none;
  user-select: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
}
</style>
